// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Components
import { Col } from '../../../../../../layout/elements/Col';
import { Row } from '../../../../../../layout/elements/Row';

export const Container = styled.div`
  height: 100%;
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.borderColor};
  margin-bottom: 1.5rem;
`;

export const ListContainer = styled(Row)`
  padding-bottom: 2rem;

  @media (min-width: ${BREAKPOINTS.lg}px) {
    row-gap: 24px;
  };
`;

export const ListCol = styled(Col)`
  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-right: 1.5rem;

    &:nth-child(2n) {
      padding-right: 0;
    };
  };
`;
